/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_Contact_ActionInputs */



/**
* | output |
* | --- |
* | "Get in touch" |
*
* @param {Pilot_Ended_Contact_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_contact_action = /** @type {((inputs?: Pilot_Ended_Contact_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_Contact_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Neem contact op")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prendre contact")
	return /** @type {LocalizedString} */ ("Get in touch")
});